import React, { createContext, useContext, useEffect, useState } from 'react';
import { auth } from './firebase';
import { onAuthStateChanged, signInWithPopup, signOut, GoogleAuthProvider } from 'firebase/auth';

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [googleToken, setGoogleToken] = useState(null); 

  // 1. All Logic first (Effects)
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, currentUser => {
      setUser(currentUser);
      if (!currentUser) setGoogleToken(null);
    });
    return () => unsubscribe();
  }, []);

  // 2. Auth Methods
  const login = async () => {
    const provider = new GoogleAuthProvider();
    provider.addScope('https://www.googleapis.com/auth/calendar.events.readonly');
    provider.addScope('https://www.googleapis.com/auth/calendar.readonly');
    
    try {
      const result = await signInWithPopup(auth, provider);
      const credential = GoogleAuthProvider.credentialFromResult(result);
      const token = credential.accessToken;
      
      setGoogleToken(token);
      return result.user;
    } catch (error) {
      console.error("Login Error:", error);
    }
  };

  const logout = () => signOut(auth);

  // 3. API Helpers
  const getAvailableCalendars = async () => {
    if (!googleToken) {
      console.warn("No Google Token found. Try logging in again.");
      return [];
    }
    try {
      const response = await fetch(
        `https://www.googleapis.com/calendar/v3/users/me/calendarList`,
        { headers: { Authorization: `Bearer ${googleToken}` } }
      );
      const data = await response.json();
      console.log("Full Google Calendar List Response:", data);
      return data.items || [];
    } catch (err) {
      console.error("Error fetching calendar list:", err);
      return [];
    }
  };

  // 4. One single Return at the very bottom
  return (
    <AuthContext.Provider value={{ user, googleToken, login, logout, getAvailableCalendars }}>
      {children}
    </AuthContext.Provider>
  );
};